import React, { PropTypes } from 'react'
import Loading from 'components/Loading'
import Button from 'components/Button'
import Alert from 'components/Alert'
import Dialog from 'components/Dialog'
import SubmitButton from 'components/SubmitButton'
import constants from 'constants'
import { generateCSV } from 'utils/generateCSV'
import PartnerPlanReminderNotificationList from './components/PartnerPlan/PartnerPlanReminderNotificationList'

const styles = Object.assign(
  {},
  require('./PartnerPlans.scss'),
  require('components/Table/Table.scss'),
  { columns: require('./columns.scss') },
)

class PartnerPlanReminderNotificationView extends React.Component {
  static propTypes = {
    completeText: PropTypes.string,
    ctaRunTestText: PropTypes.string,
    ctaText: PropTypes.string,
    getPartnerplanReminderEmailToBeSent: PropTypes.object.isRequired,
    partnerPlanReminderNotification: PropTypes.object.isRequired,
    sendPartnerplanReminderEmail: PropTypes.object.isRequired,
    submittingText: PropTypes.string,
  }
  static defaultProps = {
    ctaText: 'Send Reminder Email Now',
    ctaRunTestText: 'Send Test Reminder Email Now',
    completeText: 'Send Reminder Email Completed',
    submittingText: 'Sending reminder email..',
  }

  constructor() {
    super()

    this.state = {
      confirmDialogOpen: false,
      sendTestEmail: 'test',
      reminderEmailToBeSent: [],
      reminderFilteredList: [],
      isComplete: false,
      isPosting: false,
      isTextSearch: false,
    }
  }

  componentWillMount() {
    this.props.getPartnerplanReminderEmailToBeSent()
  }

  _openConfirmDialog = (runTest) => {
    this.setState({ confirmDialogOpen: true })
    this.setState({ sendTestEmail: runTest })
  }

  _closeConfirmDialog = () => {
    this.setState({ confirmDialogOpen: false })
    this.setState({ sendTestEmail: 'test' })
  }

  _saveConfirmDialog = () => {
    this.setState({ confirmDialogOpen: false })
    this._handleSendPartnerPlanReminderNotification()
  }

  _handleSendPartnerPlanReminderNotification = () => {
    if (this.state.reminderEmailToBeSent.length > 0) {
      const selectedEmployees = this.state.reminderEmailToBeSent.map(({
        partnerEmpId,
      }) => parseInt(partnerEmpId, 0)).join(', ')
      this.props.sendPartnerplanReminderEmail(this.props.currentUser.EmployeeId, selectedEmployees, this.props.reminderNotification, this.state.sendTestEmail)
    }
  }

  handleRemoveEmployee = (empId) => {
    const filteredReminders = this.state.reminderEmailToBeSent.filter(item => item.partnerEmpId !== empId)
    if (this.state.isTextSearch) {
      const filteredSearch = this.state.reminderFilteredList.filter(item => item.partnerEmpId !== empId)
      this.setState({ reminderFilteredList: filteredSearch })
    }
    this.setState({ reminderEmailToBeSent: filteredReminders })
  }

  _handleSubmitTest = () => {
    if (this.state.submittedFiles.length > 0) {
      this.setState({ isPosting: true }, () => {
        this.state.uploader.methods.uploadStoredFiles()
      })
    }
  }

  handleFilterRemindersList = (searchText) => {
    const filteredList = [...new Set(this.state.reminderEmailToBeSent)]
    if (searchText) {
      const filteredReminderList = filteredList.filter(item => (
        (item.partnerEmpId || '').toLowerCase().includes(searchText.toLowerCase().trim())
      || (item.partnerName || '').toLowerCase().includes(searchText.toLowerCase().trim())
      || (item.planStatus || '').toLowerCase().includes(searchText.toLowerCase().trim())))
      this.setState({
        reminderFilteredList: filteredReminderList,
        isTextSearch: true,
      })
    } else {
      this.setState({
        isTextSearch: false,
      })
    }
  }

  canSubmit = () => {
    return (this.state.reminderEmailToBeSent.length > 0 && !this.state.isTextSearch)
  }

  render() {
    const {
      ctaText,
      ctaRunTestText,
      completeText,
      submittingText,
      partnerPlanReminderNotification,
      reminderNotification,
    } = this.props

    const confirmSendReminderNotificationProps = {
      actions: [
        { label: 'CANCEL', onClick: this._closeConfirmDialog },
        { label: 'SEND NOW', onClick: this._saveConfirmDialog },
      ],
      title: `Are you sure you want to send ${reminderNotification} reminder to ${this.state.reminderEmailToBeSent.length} Partner's?`,
      active: this.state.confirmDialogOpen,
      onClose: this._closeConfirmDialog,
    }

    // eslint-disable-next-line dot-notation
    // const form = this.props.forms['PartnerPlanRatingsUpload']
    if (partnerPlanReminderNotification.isFetching) {
      return (<Loading pageLoading />)
    }

    const emailToSend = partnerPlanReminderNotification.reminderNotifications.filter(ppr => String(ppr.infoMessage) === reminderNotification)
    if (this.state.reminderEmailToBeSent.length <= 0) {
      this.setState({
        reminderEmailToBeSent: emailToSend,
      })
    }

    const currentData = this.state.isTextSearch
      ? this.state.reminderFilteredList
      : this.state.reminderEmailToBeSent

    return (
      <div className={styles.content}>
        <Alert showCloseButton={false} type="info">
          {`The below ${this.state.reminderEmailToBeSent.length} Partners will receive the ${reminderNotification} reminder email, please confirm and click 'Send Reminder Email Now' to send emails`}
        </Alert>
        <section className={styles.section}>
          {partnerPlanReminderNotification.fetched && partnerPlanReminderNotification.reminderNotifications &&
          <div>
            <PartnerPlanReminderNotificationList
              filterRemindersList={this.handleFilterRemindersList}
              header={`This will send ${reminderNotification} reminder email to ${this.state.reminderEmailToBeSent.length} Partners`}
              partnerPlanRatingsReminderItems={currentData}
              removeEmployee={this.handleRemoveEmployee}
            />
            { this.state.reminderEmailToBeSent.length > 0 ?
              <div className={styles.exportReminder}>
                <Button
                  onClick={() => {
                  generateCSV(constants.PARTNERPLAN.CSVHEADERNOTIFICATION, this.state.reminderEmailToBeSent, `partnerplan_${reminderNotification}_report`)
                  }}
                  type="flat"
                >
                EXPORT TO CSV
              </Button>
              </div>
            : '' }
          </div>
          }
          <div>
            <div className={styles.reminderNotificationSection}>
              <div className={styles.footer}>
                <div style={{ float: 'left' }}>
                  <SubmitButton
                    isLarge
                    complete={this.state.isComplete}
                    completeText={completeText} // Add validation rules
                    onClick={() => this._handleSendPartnerPlanReminderNotification()}
                    submitting={this.state.isPosting}
                    submittingText={submittingText}
                  >
                    {ctaRunTestText}
                  </SubmitButton>
                </div>
                <div>
                  <SubmitButton
                    isLarge
                    complete={this.state.isComplete}
                    completeText={completeText} // Add validation rules
                    disabled={!this.canSubmit()}
                    onClick={() => this._openConfirmDialog('send')}
                    submitting={this.state.isPosting}
                    submittingText={submittingText}
                  >
                    {ctaText}
                  </SubmitButton>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Dialog {...confirmSendReminderNotificationProps} />
      </div>
    )
  }
}

export default PartnerPlanReminderNotificationView



// WEBPACK FOOTER //
// ./src/views/PartnerPlans/PartnerPlanReminderNotification.js